import React from "react";
import { Tag } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { GatewayStatusResponse } from "../../../Api";

type BotStatus = GatewayStatusResponse["status"];

const statusTagMap: Record<
  BotStatus,
  { color: string; icon: React.ReactNode; label: string }
> = {
  READY: {
    color: "success",
    icon: <CheckCircleOutlined />,
    label: "Active & Connected",
  },
  QR: {
    color: "processing",
    icon: <LoadingOutlined />,
    label: "Awaiting QR Scan",
  },
  INITIALIZING: {
    color: "warning",
    icon: <LoadingOutlined />,
    label: "Initializing…",
  },
  DISCONNECTED: {
    color: "warning",
    icon: <ExclamationCircleOutlined />,
    label: "Reconnecting…",
  },
  AUTH_FAILURE: {
    color: "error",
    icon: <CloseCircleOutlined />,
    label: "Auth Failed",
  },
  OFFLINE: {
    color: "default",
    icon: <CloseCircleOutlined />,
    label: "Gateway Offline",
  },
};

interface GatewayStatusTagProps {
  status: BotStatus;
}

export const GatewayStatusTag = ({ status }: GatewayStatusTagProps) => {
  const tag = statusTagMap[status] ?? {
    color: "default",
    icon: <InfoCircleOutlined />,
    label: "Unknown",
  };

  return (
    <Tag color={tag.color} icon={tag.icon} className="font-semibold rounded-md text-xs">
      {tag.label}
    </Tag>
  );
};
